import { useWindowManager } from "./WindowManager";
import { calculateCenterPosition } from "./utils";
import SystemProperties from "../components/SystemProperties/SystemProperties";
import DisplayProperties from "../components/DisplayProperties/DisplayProperties";
import computerIcon from "../../../assets/images/computer_explorer-3.png";
import paintIcon from "../../../assets/images/paint_old-0.png";

// Openers for the "system" dialogs, used from My Computer, the Start menu
// and the desktop right-click menu.
export const useSystemWindows = () => {
  const { openWindow, closeWindow } = useWindowManager();

  const openSystemProperties = () => {
    let windowId = "";
    windowId = openWindow({
      windowTitle: "System Properties",
      icon: computerIcon,
      position: calculateCenterPosition(440, 440),
      isMinimized: false,
      isMaximized: false,
      component: <SystemProperties onClose={() => closeWindow(windowId)} />,
    });
  };

  const openDisplayProperties = () => {
    let windowId = "";
    windowId = openWindow({
      windowTitle: "Display Properties",
      icon: paintIcon,
      position: calculateCenterPosition(340, 440),
      isMinimized: false,
      isMaximized: false,
      component: <DisplayProperties onClose={() => closeWindow(windowId)} />,
    });
  };

  return { openSystemProperties, openDisplayProperties };
};
